/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-underscore-dangle */
// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';

// ===================Leaflet================
import { useMap } from 'react-leaflet/hooks';
import L from 'leaflet';
import { GestureHandling } from 'leaflet-gesture-handling';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';

// ===================Actions================
import {
  saveCellMouseOutMarker,
  setDataGridRows,
  setPolygonValue,
  setSaveCircle,
  setSaveLayer,
  setSaveRectangleBounds,
  setSaveRectangleEast,
  setSaveRectangleNorth,
  setSaveRectangleSouth,
  setSaveRectangleWest,
  setValueChange,
} from '../../../../actions/site';

// ===================Components================
import useSize from '../useSize';

function UseMap() {
  // ===================HOOKS================
  const dispatch = useDispatch();
  const dataAPI = useSelector((state) => state.dataAPI.stations);
  const savedDataGridRows = useSelector((state) => state.site.dataGrid.savedDataGridRows);
  const valueChange = useSelector((state) => state.site.useMap.rectangle.valueChange);
  const rectangleNorth = useSelector((state) => state.site.useMap.rectangle.North);
  const rectangleSouth = useSelector((state) => state.site.useMap.rectangle.South);
  const rectangleEast = useSelector((state) => state.site.useMap.rectangle.East);
  const rectangleWest = useSelector((state) => state.site.useMap.rectangle.West);
  const circleLat = useSelector((state) => state.site.useMap.circle.lat);
  const circleLon = useSelector((state) => state.site.useMap.circle.lon);
  const circleRadius = useSelector((state) => state.site.useMap.circle.radius);
  const clearButton = useSelector((state) => state.site.clear);
  const cellMouseOver = useSelector((state) => state.site.cellMouseOver);
  const cellMouseOut = useSelector((state) => state.site.cellMouseOut);
  const selectAllGrid = useSelector((state) => state.site.selectAll);
  const markersColors = useSelector((state) => state.site.markersColors);
  const markerFilter = useSelector((state) => state.site.filter.marker);
  const country = useSelector((state) => state.site.filter.country);
  const siteName = useSelector((state) => state.site.filter.siteName);
  const stateGrid = useSelector((state) => state.site.filter.state);
  const city = useSelector((state) => state.site.filter.city);
  const agency = useSelector((state) => state.site.filter.agency);
  const network = useSelector((state) => state.site.filter.network);
  const invertedNetwork = useSelector((state) => state.site.filter.invertedNetwork);
  const greaterLat = useSelector((state) => state.site.filter.greaterLat);
  const lessLat = useSelector((state) => state.site.filter.lessLat);
  const greaterLon = useSelector((state) => state.site.filter.greaterLon);
  const lessLon = useSelector((state) => state.site.filter.lessLon);
  const greaterAlt = useSelector((state) => state.site.filter.greaterAlt);
  const lessAlt = useSelector((state) => state.site.filter.lessAlt);
  const greaterInstallDate = useSelector((state) => state.site.filter.greaterInstallDate);
  const lessInstallDate = useSelector((state) => state.site.filter.lessInstallDate);
  const greaterEndDate = useSelector((state) => state.site.filter.greaterEndDate);
  const lessEndDate = useSelector((state) => state.site.filter.lessEndDate);
  const networkClick = useSelector((state) => state.site.networks.networkClick);

  /** *****************************************************************************************
  * isMarkerInsidePolygon function allows to know if the marker is inside in the polygon draw
  ****************************************************************************************** */
  function isMarkerInsidePolygon(marker, poly) {
    const polyPoints = poly.getLatLngs();
    const x = marker.getLatLng().lat;
    const y = marker.getLatLng().lng;
    let inside = false;
    for (let i = 0, j = polyPoints[0].length - 1; i < polyPoints[0].length; j = i++) {
      const xi = polyPoints[0][i].lat;
      const yi = polyPoints[0][i].lng;
      const xj = polyPoints[0][j].lat;
      const yj = polyPoints[0][j].lng;

      const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * ((y - yi) / (yj - yi)) + xi);
      if (intersect) {
        inside = !inside;
      }
    }
    return inside;
  }

  let layer = {};
  const mymap = useMap();
  // get size of element to resize him
  const { width, height } = useSize();

  function colorMarker() {
    const color = markersColors;
    color.forEach((elemcolor) => {
      mymap.eachLayer((layerColor) => {
        if (layerColor.options.className !== undefined) {
          const include = layerColor.options.className.includes(elemcolor.name[0]);
          if (include) {
            if (elemcolor.borderColor) {
              const highlight = {
                color: `#${elemcolor.borderColor}`, // border color
                fillColor: `#${elemcolor.color}`, // inside color
                weight: 2, // border thin
                opacity: 0.8, // border opacity
                fillOpacity: 0.7, // inside opacitty
              };
              mymap._layers[layerColor._leaflet_id].setStyle(highlight);
            }
            else {
              const highlight = {
                color: 'grey', // border color
                fillColor: `#${elemcolor.color}`, // inside color
                weight: 0.5, // border thin
                opacity: 0.8, // border opacity
                fillOpacity: 0.7, // inside opacitty
              };
              mymap._layers[layerColor._leaflet_id].setStyle(highlight);
            }
          }
        }
      });
    });
  }

  useMemo(() => {
    colorMarker();
  }, [dataAPI]);

  useMemo(() => {
    setTimeout(() => {
      colorMarker();
    }, 1000);
  }, [markerFilter,
    country,
    greaterAlt,
    greaterEndDate,
    greaterInstallDate,
    greaterLat,
    greaterLon,
    lessAlt,
    lessEndDate,
    lessInstallDate,
    lessLat,
    lessLon,
    agency,
    stateGrid,
    siteName,
    city,
    network,
    invertedNetwork,
    networkClick,
  ]);

  // function to make marker bigger when mouse on over grid row
  function onRowOver() {
    if (cellMouseOver.endDate === null) {
      const highlight = {
        radius: 12,
        opacity: 1,
        fillOpacity: 1,
      };
      mymap.eachLayer((layerOnOver) => {
        if (layerOnOver.hasOwnProperty('_latlng')) {
          if (
            (cellMouseOver.lat == layerOnOver._latlng.lat)
             && (cellMouseOver.lon == layerOnOver._latlng.lng)
          ) {
            if (layerOnOver._leaflet_id !== '' && (cellMouseOver.marker === layerOnOver.options.marker_long_name)) {
              mymap._layers[layerOnOver._leaflet_id].setStyle(highlight);
              mymap._layers[layerOnOver._leaflet_id].bringToFront();
            }
          }
        }
      });
    }
  }

  function onRowLeave() {
    if (cellMouseOut.endDate === null) {
      const highlight = {
        radius: 5,
        opacity: 0.8,
        fillOpacity: 0.7,
      };
      mymap.eachLayer((layerLeaveOut) => {
        if (layerLeaveOut._leaflet_id !== '' && (cellMouseOut.marker === layerLeaveOut.options.marker_long_name)) {
          mymap._layers[layerLeaveOut._leaflet_id].setStyle(highlight);
          mymap._layers[layerLeaveOut._leaflet_id].bringToFront();
        }
      });
    }
    dispatch(saveCellMouseOutMarker({}));
  }

  function selectAllGridStyle() {
    let highlight = {};
    if (selectAllGrid) {
      highlight = {
        radius: 12,
        opacity: 1,
        fillOpacity: 1,
      };
    }
    else {
      highlight = {
        radius: 5,
        opacity: 0.8,
        fillOpacity: 0.7,
      };
    }
    mymap.eachLayer((allLayer) => {
      if (allLayer.options.endDate === null) {
        mymap._layers[allLayer._leaflet_id].setStyle(highlight);
        mymap._layers[allLayer._leaflet_id].bringToFront();
      }
    });
  }

  // recalibration of the card after changing the size of the component
  useEffect(() => {
    if (mymap) {
      setTimeout(() => {
        mymap.invalidateSize();
      }, 100);
    }
  }, [height, width, mymap]);

  useEffect(() => {
    if (Object.keys(cellMouseOver).length > 0) {
      onRowOver();
    }
  }, [cellMouseOver]);

  useEffect(() => {
    if (Object.keys(cellMouseOut).length > 0) {
      onRowLeave();
    }
  }, [cellMouseOut]);

  useEffect(() => {
    selectAllGridStyle();
  }, [selectAllGrid]);
  // Activation de GEstureHandling for the map
  useEffect(() => {
    mymap.addHandler('gestureHandling', GestureHandling);
    mymap.gestureHandling.enable();
  }, [mymap]);

  // when creating a graphic element save these coordinates in the state
  useEffect(
    () => {
      mymap.on('draw:created', (e) => {
        let newDataList = [];
        const type = e.layerType;
        layer = e.layer;
        if (type === 'circle') {
          dispatch(setSaveCircle('', '', 0));
          const latLong = [e.layer._latlng.lat, e.layer._latlng.lng];
          const theCenterPt = latLong;
          const theRadius = e.layer._mRadius;
          const addedMarker = new Set();

          mymap.eachLayer((icon) => {
            if (icon.hasOwnProperty('_latlng')) {
              const layerlatlong = icon.getLatLng();
              const distancefromcenterPoint = layerlatlong.distanceTo(theCenterPt);
              if (distancefromcenterPoint <= theRadius) {
                dataAPI.list.data.map((el) => {
                  if (
                    el.location.coordinates.lat === layerlatlong.lat
                 && el.location.coordinates.lon === layerlatlong.lng) {
                    if (!addedMarker.has(el.marker_long_name)) {
                      newDataList.push(el);
                      addedMarker.add(el.marker_long_name);
                    }
                  }
                  return el;
                });
              }
            }
          });
          const { lat } = e.layer._latlng;
          const { lng } = e.layer._latlng;
          const radius = e.layer._mRadius / 1000;
          dispatch(setSaveCircle(lat, lng, radius));
        }
        if (type === 'rectangle') {
          dispatch(setSaveRectangleBounds('', '', '', ''));
          const bounds = L.latLngBounds(e.layer._latlngs[0], e.layer._latlngs[2]);
          const addedMarker = new Set();
          mymap.eachLayer((icon) => {
            if (icon.hasOwnProperty('_latlng')) {
              const layerlatlong = icon.getLatLng();
              if (bounds.contains(layerlatlong)) {
                dataAPI.list.data.map((el) => {
                  if (
                    el.location.coordinates.lat === layerlatlong.lat
                 && el.location.coordinates.lon === layerlatlong.lng) {
                    if (!addedMarker.has(el.marker_long_name)) {
                      newDataList.push(el);
                      addedMarker.add(el.marker_long_name);
                    }
                  }
                  return el;
                });
              }
            }
          });
          const North = e.layer._latlngs[0][2].lat.toFixed(6);
          const South = e.layer._latlngs[0][0].lat.toFixed(6);
          const East = e.layer._latlngs[0][2].lng.toFixed(6);
          const West = e.layer._latlngs[0][0].lng.toFixed(6);
          dispatch(setSaveRectangleBounds(North, South, East, West));
        }
        if (type === 'polygon') {
          dispatch(setPolygonValue(''));
          const addedMarker = new Set();

          mymap.eachLayer((icon) => {
            if (icon.hasOwnProperty('_latlng')) {
              if (isMarkerInsidePolygon(icon, e.layer)) {
                dataAPI.list.data.map((el) => {
                  if (
                    el.location.coordinates.lat === icon._latlng.lat
                 && el.location.coordinates.lon === icon._latlng.lng) {
                    if (!addedMarker.has(el.marker_long_name)) {
                      newDataList.push(el);
                      newDataList = Array.from(new Set(newDataList));
                      addedMarker.add(el.marker_long_name);
                    }
                  }
                  return el;
                });
              }
            }
          });
          const polyPoints = e.layer.getLatLngs();
          dispatch(setPolygonValue(polyPoints));
        }
        const rowsDataGrid = [];
        if (newDataList.length !== 0) {
          for (let i = 0; i <= newDataList.length - 1; i += 1) {
            const dataGridRow = {
              id: i,
              marker: newDataList[i].marker_long_name,
              site: newDataList[i].name,
              lat: newDataList[i].location.coordinates.lat,
              lon: newDataList[i].location.coordinates.lon,
              alt: newDataList[i].location.coordinates.altitude,
              installDate: newDataList[i].date_from,
              endDate: newDataList[i].date_to,
              country: newDataList[i].location.country.name,
              state: newDataList[i].location.state.name,
              city: newDataList[i].location.city.name,
              agency: newDataList[i].agency.name,
              network: newDataList[i].network.name,
            };
            rowsDataGrid.push(dataGridRow);
          }
        }
        console.log('rowsDataGrid', rowsDataGrid);
        dispatch(setDataGridRows(rowsDataGrid));
      });
      mymap.on('draw:drawstart', () => {
        dispatch(setSaveRectangleBounds('', '', '', ''));
        dispatch(setSaveCircle('', '', 0));
        dispatch(setPolygonValue(''));

        mymap.eachLayer((layer2) => {
          if (layer2._bounds !== undefined) {
            if (
              layer2._bounds._northEast !== undefined
              && layer2._bounds._southWest !== undefined) {
              if (
                layer2._bounds._northEast.lat === rectangleNorth
                && layer2._bounds._northEast.lng === rectangleEast
                && layer2._bounds._southWest.lat === rectangleSouth
                && layer2._bounds._southWest.lng === rectangleWest) {
                mymap.removeLayer(layer2);
              }
            }
          }
        });
        mymap.eachLayer((layer2) => {
          if (layer2._latlng !== undefined && layer2._mRadius !== undefined) {
            if (
              layer2._latlng.lat !== undefined
              && layer2._latlng.lng !== undefined) {
              if (
                layer2._latlng.lat !== circleLat
                && layer2._latlng.lng !== circleLon
                && layer2._mRadius !== circleRadius) {
                mymap.removeLayer(layer2);
              }
            }
          }
        });
        mymap.removeLayer(layer);
        dispatch(setDataGridRows(savedDataGridRows));
        dispatch(setSaveLayer({}));
      });

      mymap.on('draw:deleted', () => {
        mymap.removeLayer(layer);
        dispatch(setDataGridRows(savedDataGridRows));
        dispatch(setSaveLayer({}));
        dispatch(setSaveRectangleBounds('', '', '', ''));
        dispatch(setSaveCircle('', '', 0));
        dispatch(setPolygonValue(''));
      });

      if ((rectangleNorth !== '') && (rectangleSouth !== '') && (rectangleEast !== '') && (rectangleWest !== '')) {
        mymap.eachLayer((layer2) => {
          if (layer2._bounds !== undefined) {
            if (
              layer2._bounds._northEast !== undefined
              && layer2._bounds._southWest !== undefined) {
              if (
                layer2._bounds._northEast.lat !== rectangleNorth
                && layer2._bounds._northEast.lng !== rectangleEast
                && layer2._bounds._southWest.lat !== rectangleSouth
                && layer2._bounds._southWest.lng !== rectangleWest) {
                mymap.removeLayer(layer2);
              }
            }
          }
        });
        const bounds = L.latLngBounds(
          [rectangleNorth, rectangleWest],
          [rectangleSouth, rectangleEast],
        );
        const addLayer = L.rectangle(bounds);
        layer = addLayer;
        mymap.addLayer(addLayer);
        const newDataList = [];
        mymap.eachLayer((icon) => {
          if (icon.hasOwnProperty('_latlng')) {
            const layerlatlong = icon.getLatLng();
            if (bounds.contains(layerlatlong)) {
              dataAPI.list.data.map((el) => {
                if (
                  el.location.coordinates.lat === layerlatlong.lat
                   && el.location.coordinates.lon === layerlatlong.lng) {
                  if (!newDataList.includes(el)) {
                    newDataList.push(el);
                  }
                }
                return null;
              });
            }
          }
        });
        const rowsDataGrid = [];
        if (newDataList.length !== 0) {
          for (let i = 0; i <= newDataList.length - 1; i += 1) {
            const dataGridRow = {
              id: i,
              marker: newDataList[i].marker_long_name,
              site: newDataList[i].name,
              lat: newDataList[i].location.coordinates.lat,
              lon: newDataList[i].location.coordinates.lon,
              alt: newDataList[i].location.coordinates.altitude,
              installDate: newDataList[i].date_from,
              endDate: newDataList[i].date_to,
              country: newDataList[i].location.country.name,
              state: newDataList[i].location.state.name,
              city: newDataList[i].location.city.name,
              agency: newDataList[i].agency.name,
              network: newDataList[i].network.name,
            };
            rowsDataGrid.push(dataGridRow);
          }
        }
        dispatch(setDataGridRows(rowsDataGrid));
      }

      if ((rectangleNorth !== '') || (rectangleSouth !== '') || (rectangleEast !== '') || (rectangleWest !== '')) {
        mymap.eachLayer((layer3) => {
          if (layer3._latlng !== undefined && layer3._mRadius !== undefined) {
            mymap.removeLayer(layer3);
          }
        });
        if ((circleLat !== '') && (circleLon !== '') && (circleRadius > 0)) {
          dispatch(setSaveCircle('', '', 0));
        }
      }
      if ((circleLat !== '') && (circleLon !== '') && (circleRadius > 0)) {
        mymap.eachLayer((layer2) => {
          if (layer2._latlng !== undefined && layer2._mRadius !== undefined) {
            if (
              layer2._latlng.lat !== undefined
              && layer2._latlng.lng !== undefined) {
              if (
                layer2._latlng.lat !== circleLat
                || layer2._latlng.lng !== circleLon
                || layer2._mRadius !== circleRadius) {
                mymap.removeLayer(layer2);
              }
            }
          }
        });
        const addLayer = L.circle([
          parseFloat(circleLat),
          parseFloat(circleLon)], circleRadius * 1000);
        mymap.addLayer(addLayer);
        const theCenterPt = [parseFloat(circleLat), parseFloat(circleLon)];
        const theRadius = circleRadius * 1000;
        const newDataList = [];
        mymap.eachLayer((icon) => {
          if (icon.hasOwnProperty('_latlng')) {
            const layerlatlong = icon.getLatLng();
            const distancefromcenterPoint = layerlatlong.distanceTo(theCenterPt);
            if (distancefromcenterPoint <= theRadius) {
              dataAPI.list.data.map((el) => {
                if (
                  el.location.coordinates.lat === layerlatlong.lat
               && el.location.coordinates.lon === layerlatlong.lng) {
                  newDataList.push(el);
                }
                return null;
              });
            }
          }
        });
        const rowsDataGrid = [];
        if (newDataList.length !== 0) {
          for (let i = 0; i <= newDataList.length - 1; i += 1) {
            const dataGridRow = {
              id: i,
              marker: newDataList[i].marker_long_name,
              site: newDataList[i].name,
              lat: newDataList[i].location.coordinates.lat,
              lon: newDataList[i].location.coordinates.lon,
              alt: newDataList[i].location.coordinates.altitude,
              installDate: newDataList[i].date_from,
              endDate: newDataList[i].date_to,
              country: newDataList[i].location.country.name,
              state: newDataList[i].location.state.name,
              city: newDataList[i].location.city.name,
              agency: newDataList[i].agency.name,
              network: newDataList[i].network.name,
            };
            rowsDataGrid.push(dataGridRow);
          }
        }
        dispatch(setDataGridRows(rowsDataGrid));
      }

      if ((circleLat !== '') || (circleLon !== '') || (circleRadius > 0)) {
        if ((rectangleNorth !== '' && rectangleEast !== '' && rectangleSouth !== '' && rectangleWest !== '')) {
          mymap.eachLayer((layer2) => {
            if (layer2._bounds !== undefined) {
              if (
                layer2._bounds._northEast !== undefined
                && layer2._bounds._southWest !== undefined) {
                if (
                  layer2._bounds._northEast.lat !== rectangleNorth
                  && layer2._bounds._northEast.lng !== rectangleEast
                  && layer2._bounds._southWest.lat !== rectangleSouth
                  && layer2._bounds._southWest.lng !== rectangleWest) {
                  mymap.removeLayer(layer2);
                }
              }
            }
          });
          dispatch(setSaveRectangleBounds('', '', '', ''));
        }
      }
      dispatch(setValueChange(false));
    },
    [valueChange === true],
  );

  useEffect(() => {
    if (clearButton) {
      dispatch(setSaveRectangleNorth(''));
      dispatch(setSaveRectangleSouth(''));
      dispatch(setSaveRectangleEast(''));
      dispatch(setSaveRectangleWest(''));
      dispatch(setSaveCircle('', '', 0));
      mymap.eachLayer((layers) => {
        if (layers._bounds !== undefined) {
          if (
            layers._bounds._northEast !== undefined
            && layers._bounds._southWest !== undefined) {
            if (
              layers._bounds._northEast.lat !== rectangleNorth
              && layers._bounds._northEast.lng !== rectangleEast
              && layers._bounds._southWest.lat !== rectangleSouth
              && layers._bounds._southWest.lng !== rectangleWest) {
              mymap.removeLayer(layers);
            }
          }
        }
        if (layers._latlng !== undefined && layers._mRadius !== undefined) {
          if (
            layers._latlng.lat !== undefined
            && layers._latlng.lng !== undefined) {
            if (
              layers._latlng.lat !== circleLat
              || layers._latlng.lng !== circleLon
              || layers._mRadius !== circleRadius) {
              mymap.removeLayer(layers);
            }
          }
        }
      });
      dispatch(setDataGridRows(savedDataGridRows));
    }
  }, [clearButton]);

  return null;
}

export default UseMap;
